import * as actionTypes from '../Action/Actiontypes';

const initialstate = {
    loading: false,
    error: false,
    email: {},
    emaildata: {}
}

export const EmailReducer = (state = initialstate, action) => {
    switch (action.type) {
        case actionTypes.GET_EMAIL_CONGIF_INIT:
            return {
                ...state,
                loading: true
            }
        case actionTypes.GET_EMAIL_CONGIF_SUCCESS:
            return {
                ...state,
                email: action.payload,
                loading: false,

            }
        case actionTypes.GET_EMAIL_CONGIF_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false,
            }
        // CREATE EMAIL
        case actionTypes.CREATE_EMAIL_INIT:
            return {
                ...state,
                loading: true
            }
        case actionTypes.CREATE_EMAIL_SUCCESS:
            console.log(action.payload)
            return {
                ...state,
                emaildata: action.payload,
                loading: false,
            }
        case actionTypes.CREATE_EMAIL_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false,
            }
        default:
            return state;
    }
}